import React from "react";
import { Spinner } from "@kui-react/spinner";
import { Redirect, useParams } from "react-router-dom";
import {
  POSTHOG_IDENTITY_FLAGS,
  useIdentityFeatureFlagEnabled,
} from "utils/posthogFeatureFlags";

interface ManagedSecretsFeatureGateProps {
  children: React.ReactNode;
}

export const ManagedSecretsFeatureGate: React.FC<
  ManagedSecretsFeatureGateProps
> = ({ children }) => {
  const { orgId } = useParams<{ orgId?: string }>();
  const enabled = useIdentityFeatureFlagEnabled(
    POSTHOG_IDENTITY_FLAGS.BREV_SECRETS_UI,
  );

  if (enabled === undefined) {
    return (
      <div
        className="flex min-h-56 items-center justify-center"
        aria-label="Loading secrets"
      >
        <Spinner size="medium" />
      </div>
    );
  }

  if (!enabled) {
    return (
      <Redirect to={orgId ? `/org/${orgId}/launchables` : "/org/launchables"} />
    );
  }

  return <>{children}</>;
};
